<nav class="fixed bg-light w-full h-20 top-0 z-[1001] flex items-center justify-between p-6">
  <vl-icon (click)="offCanvasMobile.open()" class="!flex items-center lg:!hidden" size="xl" status="dark" pack="font-awesome-solid" icon="bars"></vl-icon>

  <a routerLink='/' class="-m-1.5 p-1.5">
    <img class="h-8 w-auto hidden xl:block" src="assets/images/verygames.png" alt="VeryGames">
    <img class="h-8 w-auto block xl:hidden" src="assets/images/verygames_min.png" alt="VeryGames">
  </a>

  <div class="hidden lg:flex gap-14">
    <ng-container *ngTemplateOutlet="navigationTemplate"></ng-container>
  </div>

  <div class="flex gap-7">
    <!-- <search-product class="hidden lg:block"></search-product> -->
    <login-buttons class="!hidden lg:!flex"></login-buttons>
    <currency-and-language display="BOTH" class="!hidden lg:!flex font-medium items-center text-sm hover:text-primary transition-colors duration-200 cursor-pointer"></currency-and-language>
    <cart class="self-center"></cart>
  </div>
</nav>

<vg-offcanvas #offCanvasMobile class="block lg:hidden">
  <vg-offcanvas-header>VeryGames</vg-offcanvas-header>
  <vg-offcanvas-body class="flex flex-col gap-4">
    <ng-container *ngTemplateOutlet="navigationTemplate"></ng-container>
    <currency-and-language display="BOTH" class="mx-auto font-medium flex items-center text-sm hover:text-primary transition-colors duration-200 cursor-pointer"></currency-and-language>
  </vg-offcanvas-body>
  <vg-offcanvas-footer>
    <login-buttons class="mx-auto w-fit justify-center"></login-buttons>
  </vg-offcanvas-footer>
</vg-offcanvas>

<ng-template #navigationTemplate>
  <ng-container *ngFor="let navigationItem of navigationItems">
    <a *ngIf="!navigationItem?.children" (click)="offCanvasMobile?.close()" [routerLink]="navigationItem.routerLink" routerLinkActive="text-primary" [routerLinkActiveOptions]="{exact: true}" class="text-base uppercase cursor-pointer font-medium mx-auto">{{ navigationItem.title }}</a>

    <ng-container *ngTemplateOutlet="absoluteNavigationTemplate; context: { navigationItem: navigationItem}"></ng-container>
  </ng-container>
</ng-template>

<ng-template #absoluteNavigationTemplate let-navigationItem="navigationItem" let-absoluteContainerClass="absoluteContainerClass">
  <div *ngIf="navigationItem?.children" #container class="relative group mx-auto" [ngClass]="{'block lg:hidden': navigationItem.mobileOnly }">
    <div class="flex gap-2" (click)="onNavigationItemEnter(navigationItem, container)">
      <a class="text-base uppercase cursor-pointer font-medium" *ngIf="!navigationItem.template">{{ navigationItem.title }}</a>

      <ng-container *ngIf="navigationItem.template">
        <ng-container *ngTemplateOutlet="navigationItem.template"></ng-container>
      </ng-container>

      <i class="flex self-center text-sm fas fa-chevron-down"></i>
    </div>

    <div *ngIf="navigationItem.hovered" class="pl-4 pt-4 flex flex-col gap-4 lg:hidden">
      <ng-container *ngFor="let child of navigationItem.children">
        <span *ngIf="child.onClick" (click)="offCanvasMobile?.close(); child.onClick.call(this);" class="text-base uppercase cursor-pointer">
          <ng-container *ngTemplateOutlet="childTemplate; context: {child: child, isParent: true}"></ng-container>
        </span>

        <a *ngIf="!child.onClick" (click)="offCanvasMobile?.close()" [routerLink]="child.routerLink" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="text-primary" class="text-base uppercase cursor-pointer">
          <ng-container *ngTemplateOutlet="childTemplate; context: {child: child, isParent: true}"></ng-container>
        </a>
      </ng-container>
    </div>

    <div *ngIf="navigationItem.hovered" [@fadeInOut] [ngClass]="absoluteContainerClass" class="absolute hidden lg:block bg-light shadow-lg -left-4 top-8 w-screen max-w-md h-fit rounded ring-1 ring-secondary/25">
      <div class="p-4">
        <ng-container *ngFor="let child of navigationItem.children">
          <a *ngIf="!child.onClick" (click)="offCanvasMobile?.close(); onNavigationItemClicked(navigationItem)" [routerLink]="child.routerLink" routerLinkActive="bg-light-600/25" [routerLinkActiveOptions]="{exact: true}" (mouseenter)="child.hovered = true" (mouseleave)="child.hovered = false" class="cursor-pointer relative flex items-center gap-x-3 rounded-lg p-3 m-1 text-sm leading-6 transition-colors duration-200 hover:bg-light-600/25">
            <ng-container *ngTemplateOutlet="childTemplate; context: {child: child, isParent: false}"></ng-container>
          </a>

          <span *ngIf="child.onClick" (click)="offCanvasMobile?.close(); onNavigationItemClicked(navigationItem); child.onClick.call(this);" (mouseenter)="child.hovered = true" (mouseleave)="child.hovered = false" class="cursor-pointer relative flex items-center gap-x-3 rounded-lg p-3 m-1 text-sm leading-6 transition-colors duration-200 hover:bg-light-600/25">
            <ng-container *ngTemplateOutlet="childTemplate; context: {child: child, isParent: false}"></ng-container>
          </span>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #childTemplate let-child="child" let-isParent="isParent">
  <ng-container *ngIf="isParent">
    <span>{{ child.title }}</span>
  </ng-container>

  <ng-container *ngIf="!isParent">
    <div class="flex h-11 w-11 flex-none items-center overflow-hidden justify-center rounded-lg bg-light-400">
      <vl-icon *ngIf="child.icon" class="!flex" [status]="child.hovered ? 'primary':'dark'" [pack]="child.icon?.pack" [icon]="child.icon?.icon" size="lg"></vl-icon>
      <img *ngIf="child.image" class="filter transition-all duration-200" [src]="child.image | SafeImageLoader" [ngClass]="child.hovered ? 'grayscale-0':'grayscale'">
    </div>

    <div class="flex-auto overflow-hidden">
      <span class="text-black">{{ child.title }}</span>
      <p *ngIf="child.description" class="text-secondary truncate">{{ child.description }}</p>
    </div>
  </ng-container>
</ng-template>

<!-- 
<div id="vgHeadbarAttachment"></div>

<div class="flex justify-center items-center gap-4 flex-wrap" id="vgHeadbarInjection">
  <search-product></search-product>
  <login-buttons></login-buttons>
  <cart></cart>
</div>
-->